var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg57(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#EE3837"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.267 41.712 38.305 20.68l-6.11-6.11L8.93 10.34l12.337 31.372Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.08 15.863-17.155-3.29 10.81 8.812 6.345-5.523Zm5.523 4.347-3.525-3.525-6.11 5.17 9.635-1.645Zm-12.808 2.82-10.693-8.813 9.048 22.796 1.645-13.983Zm12.69-1.292-10.927 1.88-1.528 13.16 12.455-15.04Z",
    fill: "#EE3837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg57);
export default __webpack_public_path__ + "static/media/57.123deae7de6718378c6f9d4c9c47aa86.svg";
export { ForwardRef as ReactComponent };